import { ApolloClient, HttpLink, InMemoryCache, ApolloLink } from "@apollo/client";
import { split } from "apollo-link";
import { getMainDefinition } from "apollo-utilities";

const httpLink = new HttpLink({
    uri: "https://db.polko.com.ar/v1/graphql",
});

const link = split(
    ({ query }) => {
        const { kind, operation } = getMainDefinition(query);
        return kind === "OperationDefinition" && operation === "subscription";
    },
    ApolloLink.from([httpLink])
);

export const apolloClient = new ApolloClient({
    link,
    cache: new InMemoryCache(),
});
